import { combineReducers, createStore, applyMiddleware } from 'redux';
import { all } from 'redux-saga/effects';
import createSagaMiddleware from 'redux-saga';
import { authSagas, authReducer } from 'components/dashboard/Auth/ducks';
import { postSagas, postReducer } from 'components/dashboard/Post/ducks';
import { tagReducer, tagSagas } from "components/dashboard/Tags/ducks";
const rootReducer = combineReducers({
  auth: authReducer,
  post: postReducer,
  tags: tagReducer,
});

export const rootSaga = function* rootSaga() {
  yield all([...authSagas, ...postSagas(), ...tagSagas()]);
};

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

export default store;
